module.exports = "https://w.yxzs.360.cn/singleapp/simulator-site-old/img/p2.35ba32ab.png";